import Grid from "@mui/material/Grid";

import FormField from "../../../layouts/ecommerce/products/new-product/components/FormField";
import MDInput from "../../../components/MDInput";
import Autocomplete from "@mui/material/Autocomplete";

import { useEffect } from "react";

// Material Dashboard 2 PRO React components
import MDBox from "../../../components/MDBox";

import { useSelector, useDispatch } from "react-redux";

import { setAllSuppliers } from "../../../redux/reducers/suppliersReducer";

import { getSuppliers } from "../../../api/suppliers";
import { deviceTypeEnum } from "../../../config/enum";

export default function SupplierInfo({
  modelName,
  setModelName,
  supplier,
  setSupplier,
  modelType,
  setModelType,
  edit,
}) {
  const dispatch = useDispatch();

  async function fetchSuppliers() {
    const response = await getSuppliers();
    const formatedSuppliers = await response.data.map((supplier) => ({
      label: supplier.supplier_name,
      id: supplier.supplier_id,
    }));
    dispatch(setAllSuppliers(formatedSuppliers));
  }

  const allSuppliers = useSelector((state) => state.suppliers.allSuppliers);

  useEffect(() => {
    fetchSuppliers();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <MDBox>
      <Grid container spacing={2}>
        <Grid item xs={4}>
          <Autocomplete
            options={allSuppliers}
            value={supplier}
            onChange={(event, newSupplier) => {
              setSupplier(newSupplier);
            }}
            renderInput={(params) => (
              <MDInput {...params} label="Choisissez le fournisseur" variant="standard" />
            )}
          />
        </Grid>
        <Grid item xs={4}>
          <FormField
            inputProps={{ maxLength: 255 }}
            value={modelName}
            onChange={(event) => setModelName(event.target.value)}
            variant="standard"
            required
            type="text"
            label="Nom"
          />
        </Grid>
        <Grid item xs={4}>
          <Autocomplete
            options={deviceTypeEnum}
            value={modelType}
            onChange={(event, newDeviceType) => {
              setModelType(newDeviceType);
            }}
            renderInput={(params) => (
              <MDInput {...params} label="Choisissez le type d'appareil" variant="standard" />
            )}
          />
        </Grid>
      </Grid>
    </MDBox>
  );
}
